<template>
  <v-card>
    <v-card-title><h3>Sales Report</h3></v-card-title>
    <v-card-text>

      <v-layout row wrap>

        <v-flex xs12 md3 class="text-xs-center" px-1 mt-2>
          <v-flex class="date__picker">
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="fromDate"
                  label="Start Date"
                  prepend-icon="event"
                  readonly
                  clearable
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="fromDate" @input="menu = false"></v-date-picker>
            </v-menu>
          </v-flex>
        </v-flex>

        <v-flex xs12 md3 class="text-xs-center" px-1 mt-2>
          <v-flex class="date__picker">
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="toDate"
                  label="End Date"
                  prepend-icon="event"
                  readonly
                  clearable
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="toDate" @input="menu1 = false"></v-date-picker>
            </v-menu>
          </v-flex>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex>
          <v-flex xs12 md12>
            <v-data-table
              :items="items"
              :headers="analyticHeaders"
              :loading="loading"
              item-key="id"
              hide-actions
              disable-initial-sort
            >
              <template slot="items" slot-scope="props">
                <tr>
                  <td>{{ props.item.id }}</td>
                  <td>{{ props.item.workcase.invoice_number }}</td>
                  <td>{{ props.item.created_at }}</td>
                  <td>{{ props.item.status }}</td>
                  <td>{{ props.item.workcase.answers ? getAnswerItem(props.item.workcase.answers, 'main_form', 'deceased_name') : '-' }}</td>
                  <td>{{ props.item.workcase.casket ? props.item.workcase.casket.name : '-' }}</td>
                  <td>{{ props.item && props.item.workcase && props.item.workcase.plan && props.item.workcase.plan.name ? props.item.workcase.plan.name : '-' }}</td>
                  <td>{{ props.item.workcase.answers ? getAnswerItem(props.item.workcase.answers, 'main_form', 'deceased_death_certificate_no') : '-' }}</td>
                  <td>{{ props.item.workcase.answers ? getAnswerItem(props.item.workcase.answers, 'main_form', 'deceased_location_of_wake') : '-' }}</td>
                  <td>{{ props.item.workcase.answers ? getAnswerItem(props.item.workcase.answers, 'agreement_form_data', 'ash_collection_location') : '-' }}</td>
                  <td>{{ props.item.workcase.answers ? getAnswerItem(props.item.workcase.answers, 'agreement_form_data', 'ash_collection_vendor') : '-' }}</td>
                  <!-- <td>{{ getClientCreated(props.item.workcase) }}</td> -->
                  <td>{{ props.item.workcase.answers ? getAnswerItem(props.item.workcase.answers, 'client_form_data', 'name') : '-' }}</td>
                  <td>{{ props.item.workcase.answers ? getAnswerItem(props.item.workcase.answers, 'client_form_data', 'mailing_address') : '-' }}</td>
                  <td>{{ props.item.workcase.answers ? getAnswerItem(props.item.workcase.answers, 'client_form_data', 'contact_number') : '-' }}</td>
                  <td>{{ props.item.workcase.answers ? getAnswerItem(props.item.workcase.answers, 'client_form_data', 'email') : '-' }}</td>
                  <td>{{ calculatePriceWithGST(props.item.workcase.totalPrice) }}</td>
                  <td>{{ props.item.workcase.payment_info ? getPaymentMode(props.item.workcase.payment_info) : '-' }}</td>
                  <td>{{ props.item.workcase.manager_name }}</td>
                  <td>{{ getCremationTime(props.item) }}</td>
                  <td>{{ props.item.workcase.answers ? getAnswerItem(props.item.workcase.answers, 'main_form', 'deceased_burial_location') : '-' }}</td>
                </tr>
              </template>
            </v-data-table>
            <div class="align-right">
              <v-btn @click="exportToCSV(items)">Export to CSV</v-btn>
            </div>
          </v-flex>
        </v-flex>
      </v-layout>

    </v-card-text>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import _ from 'lodash'
  import moment from 'moment'

  export default {
    computed: {
      ...mapGetters({
        filterCasketFromLinkedProducts: 'filterCasketFromLinkedProducts',
        getCasketById: 'getCasketById',
        getProductById: 'getProductById'
      })
    },
    data () {
      return {
        menu: false,
        menu1: false,
        fromDate: moment().startOf('month').format('YYYY-MM-DD'),
        toDate: moment().endOf('month').format('YYYY-MM-DD'),
        completedCases: [],
        items: [],
        analyticHeaders: [
          { text: 'Invoice ID', value: 'id' },
          { text: 'Invoice Number', value: 'workcase.invoice_number' },
          { text: 'Invoice Date', value: 'created_at' },
          { text: 'Invoice Status', value: 'status' },
          { text: 'Deceased Name', value: 'workcase.answers.deceased_name' },
          { text: 'Coffin Model', value: 'workcase.coffin_name' },
          { text: 'Plan Name', value: 'workcase.plan.name' },
          { text: 'Death Cert', value: 'workcase.answers.deceased_death_certificate_no' },
          { text: 'Location of Wake', value: 'workcase.answers.deceased_location_of_wake' },
          { text: 'Ashes Collection', value: 'workcase.answers.ashes_collection' },
          { text: 'Ashes Vendor', value: 'workcase.answers.ashes_vendor' },
          // { text: 'New/Return Customer', value: 'new_return_customer' },
          { text: 'Client Name', value: 'workcase.answers.client_name' },
          { text: 'Client Mailing Address', value: 'workcase.answers.client_mailing_address' },
          { text: 'Client Contact Number', value: 'workcase.answers.client_contact_number' },
          { text: 'Client Email Address', value: 'workcase.answers.client_email_address' },
          { text: 'Invoice Total', value: 'workcase.answers.Invoice Total' },
          { text: 'Payment Mode', value: 'workcase.payment_info.payment_method' },
          { text: 'Case Manager', value: 'workcase.manager_name' },
          { text: 'Cremation Date/Time', value: 'workcase.manager_name' },
          { text: 'Cremation/Burial Location', value: 'workcase.answers.deceased_burial_location' }
        ],
        loading: true
      }
    },
    watch: {
      fromDate () {
        this.requestData()
      },
      toDate () {
        this.requestData()
      }
    },
    methods: {
      filterCases () {
        let filteredCases = this.allCases

        if (this.fromDate !== null) {
          filteredCases = filteredCases.filter(c => moment(c.created_at).format('YYYY-MM-DD') >= moment(this.fromDate).format('YYYY-MM-DD'))
        }
        if (this.toDate !== null) {
          filteredCases = filteredCases.filter(c => moment(c.created_at).format('YYYY-MM-DD') <= moment(this.toDate).format('YYYY-MM-DD'))
        }

        this.completedCases = _.sortBy(filteredCases, ['id']).reverse()
      },
      getClientCreated (item) {
        const clientCreated = item.client && item.client.created_at ? moment(item.client.created_at).format('YYYY-MM-DD') : null
        const leadCreated = moment(item.created_at).format('YYYY-MM-DD')
        return clientCreated === leadCreated ? 'New' : 'Return'
      },
      getAnswerItem (answers, form, field) {
        const parsed = answers[0] ? JSON.parse(answers[0].answer) : null
        return parsed && parsed.form_answers[form][field] ? parsed.form_answers[form][field].replace(',', ';') : '-'
      },
      exportToCSV (cases) {
        const rows = []
        rows.push(['Invoice ID', 'Invoice Number', 'Invoice Date', 'Invoice Status', 'Deceased Name', 'Coffin Name', 'Plan Name', 'Death Cert', 'Location of Wake', 'Ashes Collection', 'Ashes Vendor', 'Client Name', 'Client Mailing Address', 'Client Contact Number', 'Client Email Address', 'Invoice Total', 'Payment Mode', 'Case Manager', 'Cremation Date/Time', 'Cremation/Burial Location'])

        cases.forEach(item => {
          rows.push([item.id, item.workcase.invoice_number, item.created_at, item.status, item.workcase.answers ? this.getAnswerItem(item.workcase.answers, 'main_form', 'deceased_name') : '-', item.workcase.casket ? item.workcase.casket.name : '-', item.workcase.plan && item.workcase.plan.name ? item.workcase.plan.name : '-', item.workcase.answers ? this.getAnswerItem(item.workcase.answers, 'main_form', 'deceased_death_certificate_no') : '-', item.workcase.answers ? this.getAnswerItem(item.workcase.answers, 'main_form', 'deceased_location_of_wake') : '-', item.workcase.answers ? this.getAnswerItem(item.workcase.answers, 'agreement_form_data', 'ash_collection_location') : '-', item.workcase.answers ? this.getAnswerItem(item.workcase.answers, 'agreement_form_data', 'ash_collection_vendor') : '-', item.workcase.answers ? this.getAnswerItem(item.workcase.answers, 'client_form_data', 'name') : '-', item.workcase.answers ? this.getAnswerItem(item.workcase.answers, 'client_form_data', 'mailing_address') : '-', item.workcase.answers ? this.getAnswerItem(item.workcase.answers, 'client_form_data', 'contact_number') : '-', item.workcase.answers ? this.getAnswerItem(item.workcase.answers, 'client_form_data', 'email') : '-', this.calculatePriceWithGST(item.workcase.totalPrice), item.workcase.payment_info ? this.getPaymentMode(item.workcase.payment_info) : '-', item.workcase.manager_name, this.getCremationTime(item), item.workcase.answers ? this.getAnswerItem(item.workcase.answers, 'main_form', 'deceased_burial_location') : '-'])
        })

        const periodStart = this.fromDate ? this.fromDate.toLowerCase().replace(/ /g, '_') : null
        const periodEnd = this.toDate ? this.toDate.toLowerCase().replace(/ /g, '_') : null
        let period = ''
        if (periodStart) period += `_from_${periodStart}`
        if (periodEnd) period += `_to_${periodEnd}`

        let csv = rows.map(e => e.join(',')).join('\n')
        let blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
        let csvUrl = URL.createObjectURL(blob)

        let link = document.createElement('a')
        link.setAttribute('href', csvUrl)
        link.setAttribute('download', `sales_report${period}.csv`)
        document.body.appendChild(link)

        link.click()
      },
      getPaymentMode (paymentInfo) {
        const parsed = JSON.parse(paymentInfo)
        return parsed.payment_method
      },
      getCremationTime (item) {
        const date = item.wake_end ? moment(item.wake_end).format('YYYY-MM-DD') : '-'
        const time = item.leave_funeral_time ? item.leave_funeral_time : '-:-'
        return `${date} ${time}`
      },
      prepareCases (data) {
        this.items = data.map((item) => {
          let totalPrice = 0
          item.workcase.services = _.map(item.workcase.services, (service) => {
            let productObj = this.getProductById(service.id)
            service.service = productObj
            service.commission = (productObj !== undefined && productObj.commission !== null) ? productObj.commission * service.pivot.quantity : 0
            totalPrice += (productObj !== undefined && productObj.commission !== null) ? productObj.price * service.pivot.quantity : 0
            return service
          })
          const casketID = this.filterCasketFromLinkedProducts(item.workcase.services)
          const casket = this.getCasketById(casketID)
          const casketCommission = casket && casket.commission ? casket.commission : 0
          totalPrice += casket && casket.commission ? casket.price : 0
          item.workcase.commissions = _.sumBy(item.workcase.services, 'commission') + casketCommission
          item.workcase.casket = casket
          item.workcase.totalPrice = totalPrice
          return item
        })
      },
      requestData () {
        this.loading = true
        this.$axios.get(`${this.$store.getters.config.api_host}/api/invoices/withcases?start=${this.fromDate}&end=${this.toDate}`).then(response => {
          this.prepareCases(response.data.additional_data)
          this.loading = false
        })
      },
      calculatePriceWithGST (value) {
        const gst = value / 100 * 8
        const result = Math.round((value + gst + Number.EPSILON) * 100) / 100
        return result
      }
    },
    async created () {
      const promises = []
      if (this.$store.state.plans.all.length === 0) promises.push(this.$store.dispatch('getAllPlans'))
      if (this.$store.state.products.categories.length === 0) promises.push(this.$store.dispatch('getProductsCategories'))
      if (this.$store.state.products.all.length === 0) promises.push(this.$store.dispatch('getAllProducts'))
      if (this.$store.state.products.caskets.length === 0) promises.push(this.$store.dispatch('getAllProducts'))

      Promise.all(promises).then(() => {
        this.requestData()
      })
    }
  }
</script>

<style scoped>
  .align-right {
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// SalesReport.vue?a59c888e